import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class APIUtilService {
  public APIUrl

  constructor() {
    this.APIUrl = 'https://' + window.location.hostname + (['localhost', '127.0.0.1'].includes(window.location.hostname) ? ':3000' : '/api')
  }

}
